<template>
  <b-form-group
    :label="copy.label"
    label-for="service-priority"
    :description="copy.help"
  >
    <b-form-input
      id="service-priority"
      :value="value"
      type="number"
      step="any"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

const messages = {
  fa: { label: 'اولویت نمایش در سایت', help: 'عدد بزرگ‌تر زودتر نمایش داده می‌شود؛ مثلاً ۵۰ قبل از ۴۰. این ترتیب در همهٔ زبان‌ها مشترک است و به نمایش در صفحهٔ اصلی وابسته نیست.' },
  en: { label: 'Website display priority', help: 'Higher numbers appear first, for example 50 before 40. This order applies to all languages, whether or not the service appears on the home page.' },
  ar: { label: 'أولوية العرض في الموقع', help: 'تظهر الأرقام الأكبر أولاً، مثل ٥٠ قبل ٤٠. الترتيب مشترك بين جميع اللغات ولا يعتمد على العرض في الصفحة الرئيسية.' },
}

export default {
  components: { BFormGroup, BFormInput },
  props: { value: { type: [Number, String], default: null } },
  computed: { copy() { return messages[this.$i18n.locale] || messages.fa } },
}
</script>
